
import React from 'react';
import '../css/Tools.css';
import tools from '../data/tools.json';

import Hacklang from '../images/Hacklang.png';
import JavaScript from '../images/JavaScript.png';
import MySQL from '../images/MySQL.png';
import NodeJs from '../images/NodeJs.png';
import PostgreSQL from '../images/PostgreSQL.png';
import ReactImg from '../images/React.png';
import Redux from '../images/Redux.png';
import TypeScript from '../images/TypeScript.png';

const imgNameToFile = {
  "JavaScript.png": JavaScript,
  "React.png": ReactImg,
  "TypeScript.png": TypeScript,
  "Redux.png": Redux,
  "NodeJs.png": NodeJs,
  "Hacklang.png": Hacklang,
  "MySQL.png": MySQL,
  "PostgreSQL.png": PostgreSQL,
}

const Tools = () => (
  <div className="tools-used">
    <h1>Tools I Use</h1>
    <div className="tools">
      {tools.map(t => (
        <div className="tool">
          <img alt={t.title} width={80} src={imgNameToFile[t.logo]} />
          <p>{t.title}</p>
        </div>
      ))}
    </div>
  </div>
);

export default Tools;
